'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type MouseEvent } from 'react';
import { Link } from '../../../../../i18n/i18n-navigation-link';
import { OptimizelyRole } from '../../../../../utils/constants/accessGroups';
import { type UserAccessFlags, useUserAccessFlags } from '../../../../../utils/hooks/use-user-access-flags';
import { type NavigationItem } from '../../../../../utils/types/navigation-items';
import styles from './sub-menu.module.scss';
type SubMenuProps = {
  activeSubItem: Nullable<string>;
  isExpanded: boolean;
  navItem: NavigationItem;
  onClick?: (event: MouseEvent<HTMLAnchorElement>, itemName: string) => void;
};
const itemNeedsAccessFlags = (item: NavigationItem): boolean => {
  const {
    accessControl
  } = item;
  if (!accessControl) return false;
  const {
    accessGroup,
    showOnlyForEdgeAccessGroupMembers
  } = accessControl;
  return showOnlyForEdgeAccessGroupMembers === true || Boolean(accessGroup) && accessGroup !== OptimizelyRole.Everyone;
};
const isSubMenuItemVisible = (subMenuItem: NavigationItem, accessFlags: undefined | UserAccessFlags): boolean => {
  const {
    accessControl
  } = subMenuItem;
  if (!accessControl) return true;
  if (!itemNeedsAccessFlags(subMenuItem)) return true;
  if (!accessFlags) return false;
  const {
    hasEdgeAccessGroupContent,
    optimizelyRoles
  } = accessFlags;
  if (accessControl.showOnlyForEdgeAccessGroupMembers === true) {
    return hasEdgeAccessGroupContent;
  }
  const {
    accessGroup
  } = accessControl;
  if (!accessGroup || accessGroup === OptimizelyRole.Everyone) {
    return true;
  }
  return optimizelyRoles.includes(accessGroup as OptimizelyRole);
};
export const SubMenu = t0 => {
  const $ = _c(16);
  const {
    activeSubItem,
    isExpanded,
    navItem,
    onClick
  } = t0;
  const hasSecondaryNavigation = Boolean(navItem.subMenu?.length);
  let t1;
  if ($[0] !== hasSecondaryNavigation || $[1] !== navItem.subMenu) {
    t1 = hasSecondaryNavigation && (navItem.subMenu?.some(itemNeedsAccessFlags) ?? false);
    $[0] = hasSecondaryNavigation;
    $[1] = navItem.subMenu;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const needsAccessFlags = t1;
  let t2;
  if ($[3] !== needsAccessFlags) {
    t2 = {
      enabled: needsAccessFlags
    };
    $[3] = needsAccessFlags;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const accessFlags = useUserAccessFlags(t2);
  let t3;
  if ($[5] !== isExpanded) {
    t3 = classNames(styles["sub-menu"], {
      [styles["sub-menu--expanded"]]: isExpanded
    });
    $[5] = isExpanded;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== accessFlags || $[8] !== activeSubItem || $[9] !== navItem.route || $[10] !== navItem.subMenu || $[11] !== onClick) {
    t4 = navItem.subMenu?.map(subMenuItem => isSubMenuItemVisible(subMenuItem, accessFlags) && <li key={subMenuItem.title}><Link className={classNames(styles["sub-menu__item"], {
        [styles["sub-menu__item--active"]]: subMenuItem.route === `#${activeSubItem}`
      })} data-submenu-item={true} href={navItem.route + subMenuItem.route} onClick={event => onClick?.(event, subMenuItem.route.replace("#", ""))}>{subMenuItem.title}</Link></li>);
    $[7] = accessFlags;
    $[8] = activeSubItem;
    $[9] = navItem.route;
    $[10] = navItem.subMenu;
    $[11] = onClick;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};